module.exports = __webpack_public_path__ + "img/Sj.40f1a79c.png";